const { getEnvironment } = require('./utils.mjs');

const env = getEnvironment();

// matches js template string pattern, e.g. ${VAR_NAME}
const regex = /\${([^}]+)}/gi;

function replacer(match, name) {
  return env[name] ?? match;
}

export function interpolateFields(entry) {
  if (!entry?.fields) return entry;

  return {
    ...entry,
    fields: Object.entries(entry.fields).reduce(
      (acc, [name, value]) => ({
        ...acc,
        [name]: typeof value !== 'string' ? value : interpolate(value),
      }),
      {}
    ),
  };
}

export function interpolate(str) {
  return str?.replace?.(regex, replacer) || str;
}
